import { Component, OnInit, ViewChild } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { NgForm } from '@angular/forms';
import { AdminService } from '../../_services/admin.service';
import { UserType, CustomUserStatus, CustomInputType, StatusCode } from '../../../_common/_enum/module.enum'; //USING IT IN HTML
import { PRODUCT_CONFIG, FORM_MSGS, ADMIN_UTILITY } from 'src/app/_common/product-config';
import { UserData } from '../_models/user-data';
import { Router } from '@angular/router';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit {

  @ViewChild("createUserForm", {static: false}) createUserForm: NgForm;
  
  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;

  private allUserType = [
  {displayName: "ProSight", value: 1},
 // {displayName: "Vendor", value: 2},
  {displayName: "Agent", value: 3},
 /* {displayName: "Retailer", value: 4},
  {displayName: "Policyholder", value: 5},
  {displayName: "Insured", value: 6}*/
];

  private loading: boolean = false;

  private selectedUserType = this.allUserType[1];

  private allUserRole = [
  {displayName: "Super Admin", value: 1},
  /*{displayName: "Site Admin", value: 2},
  {displayName: "Site Contributor", value: 3},
  {displayName: "Company Admin", value: 4},*/
  {displayName: "Super User", value: 5},
  {displayName: "User", value: 6}];
  
  private selectedUserRole = this.allUserRole[2];

  private allManagerRole = [
    "Coaction Underwriter", 
    "Coaction Business Manager"
  ];

  private selectedManagerRole = this.allManagerRole[0];

  private companyList = null;
  private selectedCompany = null;
  private addUserForCompanyID = null;

  private errorMessage:string = '';
  private successMessage:string = '';
  private warningMessage:string = '';
  private productConfig = PRODUCT_CONFIG;
  private formMsgs = FORM_MSGS;
  private adminMsgs = ADMIN_UTILITY;
  
  private customInputTypes = CustomInputType; //using in HTML
  private hasAccess:boolean = false;
  private borSkip:boolean = false;
  private user:UserData;

  //private killServicesOnDestroy = [];

  constructor(private router: Router, private adminService: AdminService) { }

  ngOnInit() {
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */

    this.user = new UserData();
    this.user.userTypeID = 3;
    this.user.userRoleID = 6; // HARD COADED TO USER
    this.user.safetyNowAccessFlag = true;
    this.user.psopUserManagerRole = this.allManagerRole[0];

    if(history && history.state && history.state.companyID != undefined){
      this.addUserForCompanyID = history.state.companyID;
    }

    this.fetchCompanyDetails();
  }

  setHeaderData(){
    this.headerData.pageTitle = "Create User";
    this.headerData.breadcrumb = [{itemName: "ADMIN", itemLink: "/admin"}];
    if(this.addUserForCompanyID!=null){
      this.headerData.breadcrumb.push({itemName: this.selectedCompany.companyName, itemLink: "/admin/company/"+this.addUserForCompanyID});
    }
    this.adminService.header = this.headerData;  
  }

  fetchCompanyDetails(){
    let companyDetailsSubscription = this.adminService.findProducersByCompany().subscribe((company:any)=>{
      this.companyList = company;

      this.companyList.forEach(_company => {
        let producerCodesArray = [];
        if(_company.producerCodes && _company.producerCodes.length > 0){
          producerCodesArray = _company.producerCodes.split(",").map(Number);
          producerCodesArray.sort(function(a, b){return a - b});
        }
        let newProducerCodes = [];
        producerCodesArray.forEach(producerCode => {
          newProducerCodes.push({code: producerCode, isSelected: false});
        });

        _company.producerCodesArray = newProducerCodes;
      });
      if(this.companyList && this.companyList.length> 0){
        if(this.addUserForCompanyID != null){
          this.selectedCompany = this.companyList.find((_company)=>{return _company.companyID == this.addUserForCompanyID});
        }else{
          this.selectedCompany = this.companyList[0];
        }
        this.user.companyID = this.selectedCompany.companyID;
        this.selectCompany(this.user.companyID);
        this.setHeaderData();
      }
    },error=>{
      this.companyList = null;
      this.selectedCompany = null;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });
    this.adminService.runningServices.push(companyDetailsSubscription);
  }

  selectCompany(_companyID){
    this.createUserForm['selectAllProducerCodes'] = false;
    this.companyList.forEach(_comp => {
      _comp.producerCodesArray.forEach(producerCode => {
        producerCode.isSelected = false;
      });
    });

    this.selectedCompany = this.companyList.find((_company)=>{return _company.companyID == _companyID});//_company;
  }

  selectUserType(_userTypeID){
    this.selectedUserType = this.allUserType.find((_type)=>{return _type.value == _userTypeID});
    if(this.selectedUserType.value != 1 && this.selectedUserRole.value == 1){
      this.user.userRoleID = 5;
      this.selectedUserRole = this.allUserRole.find((_role)=>{return _role.value == 5}); //HARD CODING TO Super User
    }
  }
  selectUserRole(_userRoleID){
    this.selectedUserRole = this.allUserRole.find((_role)=>{return _role.value == _userRoleID});
  }

  selectManagerRole(_managerRole){
    this.selectedManagerRole = this.allManagerRole.find((_role)=>{return _role == _managerRole});
  }

  selectAllProducers(_isSelect){
    this.selectedCompany.producerCodesArray.forEach(producerCode => {
      producerCode.isSelected = _isSelect;
    });
  }

  createUser() {
    console.log(this.selectedCompany.producerCodesArray);
    this.user.producerCodes = [];
    this.selectedCompany.producerCodesArray.forEach(_code => {
      if(_code.isSelected){
        this.user.producerCodes.push(_code.code);
      }
    });
    console.log(this.user);
    if(this.createUserForm.valid && (this.selectedCompany.producerCodesArray.length == 0 || this.user.producerCodes.length>0)){
      console.log("form is valid to create user");
      this.selectedUserType.value === 1 ? this.createInternalUser() : this.createExternalUser();
    }

  }
  

  createInternalUser() {
    this.resetAlertMessages();
    if(this.createUserForm.valid){
      this.loading = true;
      let createInternalUserSubscription = this.adminService.createInternalUser(this.user).subscribe(data => {
        let response = data.body.result;
        let error = data.body.errorContent;
        this.loading = false;
        if(response && response.isUserCreated) {
          this.successMessage = this.adminMsgs.UserAccountCreatedSuccessfully;
          if(response.oktaUID){
            this.router.navigate(['admin/user/' + response.oktaUID]);
          }
        } else {
          if(error.message == CustomUserStatus.NotFound){
            this.errorMessage = this.adminMsgs.UserAccountNotFound;
          }else{
            this.warningMessage = this.adminMsgs.UserAccountExist;
          }
        }
      },
      error => {
          this.errorMessage = this.formMsgs.SomethingWentWrong;
          this.loading = false;
      });
      this.adminService.runningServices.push(createInternalUserSubscription);
    }
  }

  createExternalUser() {
    this.resetAlertMessages();
    if(this.createUserForm.valid){
      this.loading = true;
      let createExternalUserSubscription = this.adminService.createExternalUser(this.user).subscribe(data => {
        this.loading = false;
        if(data.isUserCreated) {
          this.successMessage = this.adminMsgs.UserAccountCreatedSuccessfully;
          if(data.oktaUID){
            this.router.navigate(['admin/user/' + data.oktaUID]);
          }
        } else {
          this.warningMessage = this.adminMsgs.UserAccountExist;
        }
      },
      error => {
          this.errorMessage = this.formMsgs.SomethingWentWrong;
          this.loading = false;
      });
      this.adminService.runningServices.push(createExternalUserSubscription);
    }
  }

  resetAlertMessages(){
    this.errorMessage = "";
    this.successMessage = "";
    this.warningMessage = "";
  }
  ngOnDestroy() {
    this.adminService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}